module.exports = __webpack_public_path__ + "img/storage-2.a73d0c24.jpg";